import App from '../app/containers/App';
import LocaleHandler from '../app/containers/LocaleHandler';

import LoadableLogin from '../app/containers/Login/LoadableLogin';
import LoadableMission from '../app/containers/Mission/LoadableMission';
import LoadableSignup from '../app/containers/Signup/LoadableSignup';
import LoadableSchool from '../app/containers/School/LoadableSchool';

import LoadablePrivacy from '../app/containers/Privacy/LoadablePrivacy';
import LoadableResetPassword from '../app/containers/ResetPassword/LoadableResetPassword';
import LoadableConfirmEmail from '../app/containers/ConfirmEmail/LoadableConfirmEmail';
import LoadablePremium from '../app/containers/Premium/LoadablePremium';
import LoadablePurchase from '../app/containers/Purchase/LoadablePurchase';
import LoadableChangePlan from '../app/containers/ChangePlan/LoadableChangePlan';

import LoadableAccountSubscriptionCancel from '@dragonfruit/containers/AccountSubscriptionCancel/LoadableAccountSubscriptionCancel';

import LoadableAccount from '../app/containers/Account/LoadableAccount';
import AccountProfile from '../app/containers/Account/children/AccountProfile';
import AccountSubscriptions from '../app/containers/Account/children/AccountSubscriptions';
import AccountReferral from '../app/containers/Account/children/AccountReferral';
import AccountAchievements from '../app/containers/Account/children/AccountAchievements';

import LoadableTutors from '../app/containers/Tutors/LoadableTutors';
import LoadablePartnersDemo from '../app/containers/PartnersDemo/LoadablePartnersDemo';
import LoadablePartnersDemoConfirm from '../app/containers/PartnersDemoConfirm/LoadablePartnersDemoConfirm';
import LoadableTerms from '../app/containers/Terms/LoadableTerms';
import LoadablePaymentReceipt from '../app/containers/PaymentReceipt/LoadablePaymentReceipt';
import LoadablePayNowPaymentReceipt from '../app/containers/PayNowPaymentReceipt/LoadablePayNowPaymentReceipt';
import LoadableBankTransferPaymentReceipt from '../app/containers/BankTransferPaymentReceipt/LoadableBankTransferPaymentReceipt';
import LoadableForgotPassword from '../app/containers/ForgotPassword/LoadableForgotPassword';
import LoadableTutorSignup from '../app/containers/TutorSignup/LoadableTutorSignup';
import LoadableDeleteAccountReason from '../app/containers/DeleteAccountReason/LoadableDeleteAccountReason';
import LoadableConfirmDeleteAccount from '@dragonfruit/containers/DeleteAccountReason/child/ConfirmDeleteAccount/LoadableConfirmDeleteAccount';
import LoadableLaw from '@dragonfruit/containers/Law/LoadableLaw';
import LoadableTutorInfo from '@dragonfruit/containers/TutorSignup/components/TutorInfo/LoadableTutorInfo';
import LoadableTutorVerifyAccount from '@dragonfruit/containers/TutorSignup/components/TutorVerifyAccount/LoadableTutorVerifyAccount';
import LoadablePurchaseFAQForAPP from '@dragonfruit/containers/PurchaseFAQForAPP/LoadablePurchaseFAQForAPP';
import LoadableConvenienceStoreInstruction from '@dragonfruit/containers/ConvenienceStoreInstruction/LoadableConvenienceStoreInstruction';

import LoadableFeatureInstantQa from '@dragonfruit/containers/Features/components/InstantQa/LoadableInstantQa';
import LoadableTutorList from '@dragonfruit/containers/TutorList/LoadableTutorList';

import LoadableOauthLogin from '@dragonfruit/containers/Oauth/LoadableOauthLogin';
import LoadableConfirmLinePay from '@dragonfruit/containers/ConfirmLinePay/LoadableConfirmLinePay';
// @todo the following 2 can not be lazy loaded because of the 3rd party dependencies they are using.
// we should delve into those to find out.
import NotFound from '../app/containers/NotFound';

import generateLocaleRoutes from './utils/routesGenerator';

export const LOCALE_ROUTES_PREPEND_PATTERN = '/:locale?';

/**
 * @TODO: should we manage "locale routes" and "non-locale routes" separately?
 */
const routes = [
  {
    component: App,
    routes: [
      {
        path: '/login',
        exact: true,
        component: LoadableLogin,
        modules: ['Login'],
      },
      {
        path: '/oauth/:provider',
        exact: true,
        component: LoadableOauthLogin,
        modules: ['OauthLogin'],
      },
      {
        path: '/signup',
        exact: true,
        component: LoadableSignup,
        modules: ['Signup'],
      },
      {
        path: '/rp/:token?',
        component: LoadableResetPassword,
        exact: true,
        modules: ['ResetPassword'],
      },
      {
        path: '/confirm-email',
        component: LoadableConfirmEmail,
        exact: true,
        modules: ['ConfirmEmail'],
      },
      {
        path: '/premium',
        component: LoadablePremium,
        exact: true,
        modules: ['Premium'],
      },
      {
        path: '/purchase/:type/:id',
        component: LoadablePurchase,
        exact: true,
        modules: ['Purchase'],
      },
      {
        path: '/purchase/:paymentMethodId',
        component: LoadablePurchase,
        exact: true,
        modules: ['Purchase'],
      },
      {
        path: '/change-plan/:changePlanType/:subscriptionId/:token?',
        component: LoadableChangePlan,
        exact: true,
        modules: ['ChangePlan'],
      },
      {
        path: '/account/subscription/:subscriptionId/cancel',
        component: LoadableAccountSubscriptionCancel,
        exact: true,
        modules: ['AccountSubscriptionCancel'],
      },
      {
        path: '/account',
        component: LoadableAccount,
        modules: ['Account'],
        routes: [
          {
            path: '/account',
            component: AccountProfile,
            exact: true,
          },
          {
            path: '/account/subscriptions',
            component: AccountSubscriptions,
            exact: true,
          },
          {
            path: '/account/referral',
            component: AccountReferral,
            exact: true,
          },
          {
            path: '/account/achievements',
            component: AccountAchievements,
            exact: true,
          },
        ],
      },
      {
        path: '/become-a-tutor',
        component: LoadableTutors,
        exact: true,
        modules: ['Tutors'],
      },
      {
        path: '/partners',
        component: LoadableSchool,
        exact: true,
        modules: ['School'],
      },
      {
        path: '/partners-demo',
        component: LoadablePartnersDemo,
        exact: true,
        modules: ['PartnersDemo'],
      },
      {
        path: '/partners-demo-confirm',
        component: LoadablePartnersDemoConfirm,
        exact: true,
        modules: ['PartnersDemoConfirm'],
      },
      {
        path: '/privacy',
        component: LoadablePrivacy,
        exact: true,
        modules: ['Privacy'],
      },
      {
        path: '/terms',
        component: LoadableTerms,
        exact: true,
        modules: ['Terms'],
      },
      {
        path: '/signup-tutor',
        component: LoadableTutorSignup,
        exact: true,
        modules: ['TutorSignup'],
      },
      {
        path: '/signup-tutor/information',
        component: LoadableTutorInfo,
        exact: true,
        modules: ['TutorInfo'],
      },
      {
        path: '/signup-tutor/verify',
        component: LoadableTutorVerifyAccount,
        exact: true,
        modules: ['TutorVerifyAccount'],
      },
      {
        path: '/payment-receipt/:receiptNumber',
        exact: true,
        component: LoadablePaymentReceipt,
        modules: ['PaymentReceipt'],
      },
      {
        path: '/payment-receipt/paynow/:receiptNumber',
        exact: true,
        component: LoadablePayNowPaymentReceipt,
        modules: ['PaymentReceiptPayNow'],
      },
      {
        path: '/payment-receipt/bank-transfer/:receiptNumber',
        exact: true,
        component: LoadableBankTransferPaymentReceipt,
        modules: ['BankTransferPaymentReceipt'],
      },
      {
        path: '/forgot-password',
        exact: true,
        component: LoadableForgotPassword,
        modules: ['ForgotPassword'],
      },
      {
        path: '/mission',
        exact: true,
        component: LoadableMission,
        modules: ['Mission'],
      },
      {
        path: '/delete-account',
        component: LoadableDeleteAccountReason,
        modules: ['DeleteAccountReason'],
        exact: true,
      },
      {
        path: '/delete-account/confirm',
        component: LoadableConfirmDeleteAccount,
        modules: ['ConfirmDeleteAccount'],
        exact: true,
      },
      {
        path: '/law',
        component: LoadableLaw,
        exact: true,
        modules: ['Law'],
      },
      {
        path: '/purchase-faq-inapp',
        component: LoadablePurchaseFAQForAPP,
        exact: true,
        modules: ['PurchaseFAQForAPP'],
      },
      {
        path: '/convenience-store-instruction-inapp',
        component: LoadableConvenienceStoreInstruction,
        exact: true,
        modules: ['ConvenienceStoreInstruction'],
      },
      {
        path: '/feature/instant-qa',
        component: LoadableFeatureInstantQa,
        exact: true,
        modules: ['FeatureInstantQa'],
      },
      {
        path: '/tutors/:filterName?',
        component: LoadableTutorList,
        exact: true,
        modules: ['TutorList'],
      },
      {
        path: '/confirm-line-pay',
        component: LoadableConfirmLinePay,
        exact: true,
        modules: ['ConfirmLinePay'],
      },
    ],
  },
];

/**
 * The purpose of this function is to properly append
 * "localeRoutes" and "not found" routes to main routes.
 *
 * Both locale routes and main routes has NotFound route.
 * NotFound should be placed as the last element of both set of routes:
 *
 * main routes:
 * [
 *   ...
 *   {
 *     path: '/*',
 *     component: NotFound
 *   },
 * ]
 *
 * locale routes:
 * [
 *   ...
 *   {
 *     path: '/:locale?',
 *     component: NotFound,
 *   }
 * ]
 *
 *
 * @todo this is a temporarily hack. routes generator should accept a config
 * to allow certain route to exists only in main route / generated routes.
 */
function appendRoutesToMainRoutes(rootRoutes, localeRoutes) {
  const [rootRoute] = rootRoutes;

  const { routes } = rootRoute;

  localeRoutes[0].routes.push({
    component: NotFound,
  });

  const appendedRoutes = routes.concat(localeRoutes);

  appendedRoutes.push({
    component: NotFound,
  });

  return [
    {
      ...rootRoute,
      routes: appendedRoutes,
    },
  ];
}

const localeRoutes = generateLocaleRoutes(
  routes,
  LOCALE_ROUTES_PREPEND_PATTERN,
  [
    {
      depth: 0,
      pathMatcher: undefined,
      callback: route => ({
        ...route,
        path: LOCALE_ROUTES_PREPEND_PATTERN,
        component: LocaleHandler,
      }),
    },
  ]
);

// @todo a temporatory hack for not found page. fixme.
const resultRoutes = appendRoutesToMainRoutes(routes, localeRoutes);

export default resultRoutes;



// WEBPACK FOOTER //
// ./app/routes.js